import React from 'react'

const SeminarFv = () => {
  return (
    <section className="seminarFv">
      <h1 className="seminarFv__heading1">セミナー</h1>
      <p className="seminarFv__text">
        株式会社メイツでは、学習塾向けの
        <span>無料セミナーを定期的に開催しています。</span>
      </p>
    </section>
  )
}

export default SeminarFv
